module.exports = __webpack_public_path__ + "img/Frame-97.ffc038c1.svg";